import { z } from "zod";
//#region src/network/network.ts
/**
* These enum values (currently) match the NaaS DB values, though that may not
* be guaranteed in the future.
*
* The enum values do *not* match the protobuf values ({@link https://github.com/OMGWINNING/protobufs/blob/master/src/main/proto/common.proto#L57 explanation}).
*
* But the keys MUST match the protobuf keys in order for us to move towards compatibility with dynamic config.
*/
let Network = /* @__PURE__ */ function(Network) {
	Network[Network["ETH_MAINNET"] = 0] = "ETH_MAINNET";
	Network[Network["ETH_ROPSTEN"] = 1] = "ETH_ROPSTEN";
	Network[Network["ETH_RINKEBY"] = 2] = "ETH_RINKEBY";
	Network[Network["ETH_KOVAN"] = 3] = "ETH_KOVAN";
	Network[Network["ETH_GOERLI"] = 4] = "ETH_GOERLI";
	Network[Network["ETH_SEPOLIA"] = 5] = "ETH_SEPOLIA";
	Network[Network["ETH_HOLESKY"] = 6] = "ETH_HOLESKY";
	Network[Network["ETH_HOODI"] = 9] = "ETH_HOODI";
	Network[Network["FLOW_MAINNET"] = 300] = "FLOW_MAINNET";
	Network[Network["FLOW_TESTNET"] = 301] = "FLOW_TESTNET";
	Network[Network["ARB_MAINNET"] = 201] = "ARB_MAINNET";
	Network[Network["ARB_RINKEBY"] = 203] = "ARB_RINKEBY";
	Network[Network["ARB_GOERLI"] = 205] = "ARB_GOERLI";
	Network[Network["ARB_SEPOLIA"] = 206] = "ARB_SEPOLIA";
	Network[Network["MATIC_MAINNET"] = 401] = "MATIC_MAINNET";
	Network[Network["MATIC_MUMBAI"] = 406] = "MATIC_MUMBAI";
	Network[Network["MATIC_AMOY"] = 407] = "MATIC_AMOY";
	Network[Network["OPT_MAINNET"] = 501] = "OPT_MAINNET";
	Network[Network["OPT_KOVAN"] = 504] = "OPT_KOVAN";
	Network[Network["OPT_GOERLI"] = 505] = "OPT_GOERLI";
	Network[Network["OPT_SEPOLIA"] = 506] = "OPT_SEPOLIA";
	Network[Network["SOLANA_MAINNET"] = 701] = "SOLANA_MAINNET";
	Network[Network["SOLANA_DEVNET"] = 703] = "SOLANA_DEVNET";
	Network[Network["ASTAR_MAINNET"] = 801] = "ASTAR_MAINNET";
	Network[Network["POLYGONZKEVM_MAINNET"] = 901] = "POLYGONZKEVM_MAINNET";
	Network[Network["POLYGONZKEVM_TESTNET"] = 902] = "POLYGONZKEVM_TESTNET";
	Network[Network["POLYGONZKEVM_CARDONA"] = 903] = "POLYGONZKEVM_CARDONA";
	Network[Network["STARKNET_MAINNET"] = 1001] = "STARKNET_MAINNET";
	Network[Network["STARKNET_GOERLI"] = 1002] = "STARKNET_GOERLI";
	Network[Network["STARKNET_SEPOLIA"] = 1003] = "STARKNET_SEPOLIA";
	Network[Network["BASE_MAINNET"] = 1101] = "BASE_MAINNET";
	Network[Network["BASE_GOERLI"] = 1102] = "BASE_GOERLI";
	Network[Network["BASE_SEPOLIA"] = 1103] = "BASE_SEPOLIA";
	Network[Network["TEMPO_MAINNET"] = 1161] = "TEMPO_MAINNET";
	Network[Network["TEMPO_TESTNET"] = 1162] = "TEMPO_TESTNET";
	Network[Network["TEMPO_MODERATO"] = 1163] = "TEMPO_MODERATO";
	Network[Network["ZKSYNC_MAINNET"] = 1201] = "ZKSYNC_MAINNET";
	Network[Network["ZKSYNC_SEPOLIA"] = 1202] = "ZKSYNC_SEPOLIA";
	Network[Network["ZORA_MAINNET"] = 1301] = "ZORA_MAINNET";
	Network[Network["ZORA_SEPOLIA"] = 1302] = "ZORA_SEPOLIA";
	Network[Network["FRAX_MAINNET"] = 1401] = "FRAX_MAINNET";
	Network[Network["FRAX_SEPOLIA"] = 1402] = "FRAX_SEPOLIA";
	Network[Network["BNB_MAINNET"] = 1501] = "BNB_MAINNET";
	Network[Network["BNB_TESTNET"] = 1502] = "BNB_TESTNET";
	Network[Network["AVAX_MAINNET"] = 1601] = "AVAX_MAINNET";
	Network[Network["AVAX_FUJI"] = 1602] = "AVAX_FUJI";
	Network[Network["ARBNOVA_MAINNET"] = 1701] = "ARBNOVA_MAINNET";
	Network[Network["ALCHEMY_MAINNET"] = 1801] = "ALCHEMY_MAINNET";
	Network[Network["ALCHEMY_SEPOLIA"] = 1802] = "ALCHEMY_SEPOLIA";
	Network[Network["ALCHEMY_INTERNAL"] = 1803] = "ALCHEMY_INTERNAL";
	Network[Network["WORLDCHAIN_MAINNET"] = 1901] = "WORLDCHAIN_MAINNET";
	Network[Network["WORLDCHAIN_SEPOLIA"] = 1902] = "WORLDCHAIN_SEPOLIA";
	Network[Network["ZETACHAIN_MAINNET"] = 2001] = "ZETACHAIN_MAINNET";
	Network[Network["ZETACHAIN_TESTNET"] = 2002] = "ZETACHAIN_TESTNET";
	Network[Network["BLAST_MAINNET"] = 2101] = "BLAST_MAINNET";
	Network[Network["BLAST_SEPOLIA"] = 2102] = "BLAST_SEPOLIA";
	Network[Network["SCROLL_MAINNET"] = 2201] = "SCROLL_MAINNET";
	Network[Network["SCROLL_SEPOLIA"] = 2202] = "SCROLL_SEPOLIA";
	Network[Network["LINEA_MAINNET"] = 2301] = "LINEA_MAINNET";
	Network[Network["LINEA_SEPOLIA"] = 2302] = "LINEA_SEPOLIA";
	Network[Network["GNOSIS_MAINNET"] = 2401] = "GNOSIS_MAINNET";
	Network[Network["GNOSIS_CHIADO"] = 2402] = "GNOSIS_CHIADO";
	Network[Network["FANTOM_MAINNET"] = 2501] = "FANTOM_MAINNET";
	Network[Network["FANTOM_TESTNET"] = 2502] = "FANTOM_TESTNET";
	Network[Network["MANTLE_MAINNET"] = 2601] = "MANTLE_MAINNET";
	Network[Network["MANTLE_SEPOLIA"] = 2602] = "MANTLE_SEPOLIA";
	Network[Network["CELO_MAINNET"] = 2701] = "CELO_MAINNET";
	Network[Network["CELO_BAKLAVA"] = 2703] = "CELO_BAKLAVA";
	Network[Network["BERACHAIN_MAINNET"] = 2803] = "BERACHAIN_MAINNET";
	Network[Network["BERACHAIN_ARTIO"] = 2801] = "BERACHAIN_ARTIO";
	Network[Network["BERACHAIN_BARTIO"] = 2802] = "BERACHAIN_BARTIO";
	Network[Network["BERACHAIN_BEPOLIA"] = 2804] = "BERACHAIN_BEPOLIA";
	Network[Network["METIS_MAINNET"] = 2901] = "METIS_MAINNET";
	Network[Network["OPBNB_MAINNET"] = 3001] = "OPBNB_MAINNET";
	Network[Network["OPBNB_TESTNET"] = 3002] = "OPBNB_TESTNET";
	Network[Network["POLYNOMIAL_MAINNET"] = 3101] = "POLYNOMIAL_MAINNET";
	Network[Network["POLYNOMIAL_SEPOLIA"] = 3102] = "POLYNOMIAL_SEPOLIA";
	Network[Network["SHAPE_MAINNET"] = 3201] = "SHAPE_MAINNET";
	Network[Network["SHAPE_SEPOLIA"] = 3202] = "SHAPE_SEPOLIA";
	Network[Network["BOB_MAINNET"] = 3301] = "BOB_MAINNET";
	Network[Network["BOB_SEPOLIA"] = 3302] = "BOB_SEPOLIA";
	Network[Network["CROSSFI_TESTNET"] = 3401] = "CROSSFI_TESTNET";
	Network[Network["CROSSFI_MAINNET"] = 3402] = "CROSSFI_MAINNET";
	Network[Network["IOTA_MAINNET"] = 3501] = "IOTA_MAINNET";
	Network[Network["IOTA_TESTNET"] = 3502] = "IOTA_TESTNET";
	Network[Network["MODE_MAINNET"] = 3601] = "MODE_MAINNET";
	Network[Network["MODE_SEPOLIA"] = 3602] = "MODE_SEPOLIA";
	Network[Network["MOONBASE_ALPHA"] = 3701] = "MOONBASE_ALPHA";
	Network[Network["MOONBEAM_MAINNET"] = 3801] = "MOONBEAM_MAINNET";
	Network[Network["MOONRIVER_MAINNET"] = 3901] = "MOONRIVER_MAINNET";
	Network[Network["PALM_MAINNET"] = 4001] = "PALM_MAINNET";
	Network[Network["PALM_TESTNET"] = 4002] = "PALM_TESTNET";
	Network[Network["SHIDEN_MAINNET"] = 4101] = "SHIDEN_MAINNET";
	Network[Network["SHIDEN_SHIBUYA"] = 4102] = "SHIDEN_SHIBUYA";
	Network[Network["SEI_MAINNET"] = 4201] = "SEI_MAINNET";
	Network[Network["SEI_TESTNET"] = 4202] = "SEI_TESTNET";
	Network[Network["KINTO_MAINNET"] = 4301] = "KINTO_MAINNET";
	Network[Network["PLUME_TESTNET"] = 4402] = "PLUME_TESTNET";
	Network[Network["ANIME_MAINNET"] = 4501] = "ANIME_MAINNET";
	Network[Network["ANIME_SEPOLIA"] = 4502] = "ANIME_SEPOLIA";
	Network[Network["RACE_MAINNET"] = 4601] = "RACE_MAINNET";
	Network[Network["RACE_SEPOLIA"] = 4602] = "RACE_SEPOLIA";
	Network[Network["APECHAIN_MAINNET"] = 4701] = "APECHAIN_MAINNET";
	Network[Network["APECHAIN_CURTIS"] = 4702] = "APECHAIN_CURTIS";
	Network[Network["APEX_MAINNET"] = 4801] = "APEX_MAINNET";
	Network[Network["BOSS_MAINNET"] = 4901] = "BOSS_MAINNET";
	Network[Network["LENS_MAINNET"] = 5001] = "LENS_MAINNET";
	Network[Network["LENS_SEPOLIA"] = 5002] = "LENS_SEPOLIA";
	Network[Network["SONEIUM_MAINNET"] = 5101] = "SONEIUM_MAINNET";
	Network[Network["SONEIUM_MINATO"] = 5102] = "SONEIUM_MINATO";
	Network[Network["GEIST_MAINNET"] = 5201] = "GEIST_MAINNET";
	Network[Network["GEIST_POLTER"] = 5202] = "GEIST_POLTER";
	Network[Network["SOCIALNETWORK_TESTNET"] = 5301] = "SOCIALNETWORK_TESTNET";
	Network[Network["SOCIALNETWORK_MAINNET"] = 5302] = "SOCIALNETWORK_MAINNET";
	Network[Network["ALCHEMYARB_FAM"] = 5501] = "ALCHEMYARB_FAM";
	Network[Network["ALCHEMYARB_SEPOLIA"] = 5502] = "ALCHEMYARB_SEPOLIA";
	Network[Network["ROOTSTOCK_MAINNET"] = 5601] = "ROOTSTOCK_MAINNET";
	Network[Network["ROOTSTOCK_TESTNET"] = 5602] = "ROOTSTOCK_TESTNET";
	Network[Network["LUMIA_PRISM"] = 5701] = "LUMIA_PRISM";
	Network[Network["LUMIA_TESTNET"] = 5702] = "LUMIA_TESTNET";
	Network[Network["UNICHAIN_MAINNET"] = 5801] = "UNICHAIN_MAINNET";
	Network[Network["UNICHAIN_SEPOLIA"] = 5802] = "UNICHAIN_SEPOLIA";
	Network[Network["SONIC_MAINNET"] = 5901] = "SONIC_MAINNET";
	Network[Network["SONIC_TESTNET"] = 5902] = "SONIC_TESTNET";
	Network[Network["SONIC_BLAZE"] = 5903] = "SONIC_BLAZE";
	Network[Network["SPOTLIGHT_SEPOLIA"] = 6001] = "SPOTLIGHT_SEPOLIA";
	Network[Network["SPOTLIGHT_MAINNET"] = 6002] = "SPOTLIGHT_MAINNET";
	Network[Network["XMTP_TESTNET"] = 6101] = "XMTP_TESTNET";
	Network[Network["CHILIZ_MAINNET"] = 6201] = "CHILIZ_MAINNET";
	Network[Network["CHILIZ_SPICY"] = 6202] = "CHILIZ_SPICY";
	Network[Network["ABSTRACT_MAINNET"] = 6301] = "ABSTRACT_MAINNET";
	Network[Network["ABSTRACT_TESTNET"] = 6302] = "ABSTRACT_TESTNET";
	Network[Network["K2_TESTNET"] = 6401] = "K2_TESTNET";
	Network[Network["METABASED_STRATOS"] = 6501] = "METABASED_STRATOS";
	Network[Network["MONAD_TESTNET"] = 6602] = "MONAD_TESTNET";
	Network[Network["MONAD_MAINNET"] = 6603] = "MONAD_MAINNET";
	Network[Network["SUPERSEED_MAINNET"] = 6701] = "SUPERSEED_MAINNET";
	Network[Network["SUPERSEED_SEPOLIA"] = 6702] = "SUPERSEED_SEPOLIA";
	Network[Network["DEGEN_MAINNET"] = 6801] = "DEGEN_MAINNET";
	Network[Network["DEGEN_SEPOLIA"] = 6802] = "DEGEN_SEPOLIA";
	Network[Network["UNITE_MAINNET"] = 6901] = "UNITE_MAINNET";
	Network[Network["UNITE_TESTNET"] = 6902] = "UNITE_TESTNET";
	Network[Network["SETTLUS_MAINNET"] = 7001] = "SETTLUS_MAINNET";
	Network[Network["SETTLUS_SEPTESTNET"] = 7002] = "SETTLUS_SEPTESTNET";
	Network[Network["INK_MAINNET"] = 7101] = "INK_MAINNET";
	Network[Network["INK_SEPOLIA"] = 7102] = "INK_SEPOLIA";
	Network[Network["ODYSSEY_SEPOLIA"] = 7201] = "ODYSSEY_SEPOLIA";
	Network[Network["RONIN_MAINNET"] = 7301] = "RONIN_MAINNET";
	Network[Network["RONIN_SAIGON"] = 7302] = "RONIN_SAIGON";
	Network[Network["STANDARD_MAINNET"] = 7401] = "STANDARD_MAINNET";
	Network[Network["STANDARD_TESTNET"] = 7402] = "STANDARD_TESTNET";
	Network[Network["SYNDICATE_EXO"] = 7601] = "SYNDICATE_EXO";
	Network[Network["HUMANITY_MAINNET"] = 7701] = "HUMANITY_MAINNET";
	Network[Network["HUMANITY_TESTNET"] = 7702] = "HUMANITY_TESTNET";
	Network[Network["XPROTOCOL_MAINNET"] = 7801] = "XPROTOCOL_MAINNET";
	Network[Network["XPROTOCOL_SEPOLIA"] = 7802] = "XPROTOCOL_SEPOLIA";
	Network[Network["SPARKPOINT_MAINNET"] = 7901] = "SPARKPOINT_MAINNET";
	Network[Network["SPARKPOINT_TESTNET"] = 7902] = "SPARKPOINT_TESTNET";
	Network[Network["ALTERSCOPE_MAINNET"] = 8001] = "ALTERSCOPE_MAINNET";
	Network[Network["ALTERSCOPE_SEPOLIA"] = 8002] = "ALTERSCOPE_SEPOLIA";
	Network[Network["GENSYN_TESTNET"] = 8201] = "GENSYN_TESTNET";
	Network[Network["TEA_MAINNET"] = 8101] = "TEA_MAINNET";
	Network[Network["TEA_SEPOLIA"] = 8102] = "TEA_SEPOLIA";
	Network[Network["OPENLOOT_SEPOLIA"] = 8301] = "OPENLOOT_SEPOLIA";
	Network[Network["RISE_TESTNET"] = 8402] = "RISE_TESTNET";
	Network[Network["BITCOIN_MAINNET"] = 8501] = "BITCOIN_MAINNET";
	Network[Network["BITCOIN_TESTNET"] = 8502] = "BITCOIN_TESTNET";
	Network[Network["BITCOIN_SIGNET"] = 8503] = "BITCOIN_SIGNET";
	Network[Network["MARS_TESTNET"] = 8601] = "MARS_TESTNET";
	Network[Network["EARNM_SEPOLIA"] = 8701] = "EARNM_SEPOLIA";
	Network[Network["STORY_MAINNET"] = 8801] = "STORY_MAINNET";
	Network[Network["STORY_AENEID"] = 8802] = "STORY_AENEID";
	Network[Network["WYLERCHAIN_SEPOLIA"] = 8901] = "WYLERCHAIN_SEPOLIA";
	Network[Network["MEGAETH_MAINNET"] = 9001] = "MEGAETH_MAINNET";
	Network[Network["MEGAETH_TESTNET"] = 9002] = "MEGAETH_TESTNET";
	Network[Network["APTOS_MAINNET"] = 9101] = "APTOS_MAINNET";
	Network[Network["APTOS_TESTNET"] = 9102] = "APTOS_TESTNET";
	Network[Network["SUI_MAINNET"] = 9201] = "SUI_MAINNET";
	Network[Network["SUI_TESTNET"] = 9202] = "SUI_TESTNET";
	Network[Network["WORLDMOBILE_DEVNET"] = 9302] = "WORLDMOBILE_DEVNET";
	Network[Network["CONVERGE_TESTNET"] = 9402] = "CONVERGE_TESTNET";
	Network[Network["HYPERLIQUID_MAINNET"] = 9901] = "HYPERLIQUID_MAINNET";
	Network[Network["HYPERLIQUID_TESTNET"] = 9902] = "HYPERLIQUID_TESTNET";
	Network[Network["V_DEVNET"] = 1073] = "V_DEVNET";
	Network[Network["PLASMA_MAINNET"] = 11001] = "PLASMA_MAINNET";
	Network[Network["CELO_SEPOLIA"] = 2704] = "CELO_SEPOLIA";
	Network[Network["ROBINHOOD_MAINNET"] = 12101] = "ROBINHOOD_MAINNET";
	Network[Network["ROBINHOOD_TESTNET"] = 12102] = "ROBINHOOD_TESTNET";
	Network[Network["STELLAR_MAINNET"] = 12201] = "STELLAR_MAINNET";
	return Network;
}({});
/**
* Static set of all valid `NetworkIds`. Once we're depending on the Alchemy `DynamicConfigService`,
* we won't be able to maintain a static set of `NetworkIds`, so this object should be used sparingly
* in the meantime.
*
* For now, it's mostly used as a placeholder for `NetworkId` validation and in tests.
*/
const NETWORK_IDS = new Set(Object.keys(Network).filter((key) => isNaN(Number(key))));
const SOLANA_NETWORK_IDS = ["SOLANA_MAINNET", "SOLANA_DEVNET"];
const isSolanaNetwork = (networkId) => SOLANA_NETWORK_IDS.includes(networkId);
const STELLAR_NETWORK_IDS = ["STELLAR_MAINNET"];
const isStellarNetwork = (networkId) => STELLAR_NETWORK_IDS.includes(networkId);
let Availability = /* @__PURE__ */ function(Availability) {
	/**
	* Prelease networks are visible only to feature flagged teams.
	*/
	Availability["PRERELEASE"] = "prerelease";
	/**
	* Public networks are visible to everyone.
	*/
	Availability["PUBLIC"] = "public";
	/**
	* Deprecated networks are not visible to anyone.
	*/
	Availability["DEPRECATED"] = "deprecated";
	return Availability;
}({});
/**
* A zod schema for validating `NetworkId` values.
*/
const NetworkIdSchema = z.string().transform((v) => v);
/**
* Non standard network id mappings to standard network ids.
* Some networks in Druid and Orb use non-standard network ids that come from external services we have no control over.
* This map is used to convert them to standard network ids.
* NOTE: convert the raw input network id to upper case before using this map.
*/
const NON_STANDARD_NETWORK_IDS = {
	ARBMAINNET: "ARB_MAINNET",
	ARBSEPOLIA: "ARB_SEPOLIA",
	BASEMAINNET: "BASE_MAINNET",
	BASESEPOLIA: "BASE_SEPOLIA",
	BERACHAIN_BARTIO: "BERACHAIN_BARTIO",
	HOLESKY: "ETH_HOLESKY",
	MAINNET: "ETH_MAINNET",
	SEPOLIA: "ETH_SEPOLIA",
	HOODI: "ETH_HOODI",
	MATICAMOY: "MATIC_AMOY",
	MATICMAINNET: "MATIC_MAINNET",
	OPTMAINNET: "OPT_MAINNET",
	OPTIMISM_MAINNET: "OPT_MAINNET",
	OPTSEPOLIA: "OPT_SEPOLIA",
	OPTIMISM_SEPOLIA: "OPT_SEPOLIA",
	SOLDEVNET: "SOLANA_DEVNET",
	SOLMAINNET: "SOLANA_MAINNET",
	WORLDCHAINMAINNET: "WORLDCHAIN_MAINNET",
	WORLDCHAINSEPOLIA: "WORLDCHAIN_SEPOLIA",
	ZKSYNCMAINNET: "ZKSYNC_MAINNET",
	ZKSYNCSEPOLIA: "ZKSYNC_SEPOLIA"
};
//#endregion
export { Availability, NETWORK_IDS, NON_STANDARD_NETWORK_IDS, Network, NetworkIdSchema, SOLANA_NETWORK_IDS, STELLAR_NETWORK_IDS, isSolanaNetwork, isStellarNetwork };

//# sourceMappingURL=network.js.map